import './styles.scss'
import Label from 'components/Label';

import LoactionCountry from './LocationCountry';
import LocationNav from './LocationNav';
import { useSelector } from 'react-redux';
import { selectLocations } from 'store/slices/LocationsSlice';
import { useRef } from 'react';
import { useAnimation } from 'hooks/useAnimation';


const Locations = ({ locationsText, isLoading }) => {
    const container = useRef();

    useAnimation({
        items: ['.locations h2', '.locations-container', '.locations-item'],
        container,
        dependencies: [isLoading],
    })

    const locations = useSelector(selectLocations);
    if (locations.length === 0) return
    const {
        //  id,
        tag,
        title,
        description,
        view_all_button_text,
        view_all_button_link_text, } = locationsText

    return (
        <section ref={container} className="container locations">
            <Label text={tag} />
            <h2>{title}</h2>
            {
                description && <div className='body1'>{description}</div>
            }

            <div className='locations-container'>
                {view_all_button_text && view_all_button_link_text ?
                    (locations?.slice(0, 7).map((item, index) => (
                        <LoactionCountry key={index} data={item} />
                    ))) :
                    (
                        locations?.slice(0, 8).map((item, index) => (
                            <LoactionCountry key={index} data={item} />
                        ))
                    )

                }
                {view_all_button_text && view_all_button_link_text && <LocationNav upperText={view_all_button_text} lowerText={view_all_button_link_text} />}
            </div>

        </section>
    );
}

export default Locations;